/**
 * Parse the URL of a QR scan into restoId/qrId/qrToken.
 *
 * Canonical scheme:
 *   /{restoId}/{qrId}?k=<qrToken>
 *
 * Trailing slash tolerated. Anything that isn't exactly 2 path segments
 * returns null and falls back to the InvalidQrPage.
 */
export interface ParsedQr {
  restoId: string;
  qrId: string;
  qrToken: string | null;
  sessionId: string;
}

export const parseQrFromLocation = (
  pathname: string,
  search: string
): ParsedQr | null => {
  const m = pathname.match(/^\/([^/]+)\/([^/]+)\/?$/);
  if (!m) return null;
  const restoId = decodeURIComponent(m[1]);
  const qrId = decodeURIComponent(m[2]);
  if (!restoId || !qrId) return null;

  const qrToken = new URLSearchParams(search).get("k");
  return {
    restoId,
    qrId,
    qrToken,
    sessionId: `${restoId}_${qrId}`,
  };
};
